import { ExcentSubmitButton1 } from "../../pages/activeProfiling/activeProfiling.styles";

export const Header = () => {
  const sendLogoEvent = () => {
    const parentWindow = window.parent;
    parentWindow.postMessage("AlisedaLogoClicked", "*");
  };

  return (
    <header className="flex w-full header">
      <div
        className=""
        style={{ height: "80px", display: "flex", alignItems: "center" }}
      >
        <ExcentSubmitButton1 onClick={() => sendLogoEvent()} width="100">
          Volver
        </ExcentSubmitButton1>
        {/* <img src={clientLogo} alt="" className="aliseda-logo" onClick={() => {
          sendLogoEvent();
        }}/> */}
      </div>
    </header>
  );
};

export default Header;
